import { Offer } from '@rumblefish/ui/Rumblefish23Theme';
import { StyledSection } from '../AiKnowledgeManagementSolutions.styles';
import { customThresholds, howRagWorksData } from './HowRagWorks.data';

export const HowRagWorks = () => {
  return (
    <StyledSection width="normal">
      <Offer
        title="How Enterprise RAG Works"
        description="The technology behind intelligent knowledge management"
        data={howRagWorksData}
        height={'240px'}
        thresholds={customThresholds}
      />
    </StyledSection>
  );
};
